module.exports = __webpack_public_path__ + "img/5.f4991c1b.jpg";